<template>
    <form-content :id="value" class="b_shopping_form content" @send="onSend" />
</template>

<script>
import { mapActions } from 'vuex';
import FormContent from '@/components/forms';

export default {
    components: {
        FormContent
    },

    props: {
        value: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            form: {}
        };
    },

    async created() {
        try {
            this.form = await this.getForm(this.value);
        } catch (err) {
            console.error(err);

            this.$toasted.global.error();
        }
    },

    methods: {
        ...mapActions({
            getForm: 'forms/show'
        }),

        onSend() {
            this.$toasted.success('הטופס נשלח בהצלחה!');
        }
    }
};
</script>
